export const DEBOUNCE_TIME_500 = 500;
export const DEBOUNCE_TIME_300 = 300;
export const DEBOUNCE_TIME_50 = 50;
